var map = {
	"./facts_1924.jpg": "d588",
	"./facts_1929.jpg": "4027",
	"./facts_1935.jpg": "f6cc",
	"./facts_1941.jpg": "3a35",
	"./facts_1950.jpg": "b91e",
	"./facts_1958.jpg": "d5fd",
	"./facts_1961.jpg": "492a",
	"./facts_1984.jpg": "1130"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "561a";